import { ActivityByProgressDayInfoMapper } from "@/data/mapper/treatment/activity-by-progress-day-info-mappert";
import { AddTreatmentResponseInfoMapper } from "@/data/mapper/treatment/add-treatment-info-mapper";
import { TreatmentDetailResponseMapper } from "@/data/mapper/treatment/treatment-detail-reponse-mapper";
import { AddTreatmentRequestPayload } from "@/data/payload/treatment/add-treatment-request-payload";
import { FetchActivityChartDataRequestPayload } from "@/data/payload/treatment/fetch-activity-chart-data-request-payload";
import { FetchPatientTreatmentListRequestPayload } from "@/data/payload/treatment/fetch-patient-treatement-list-request-payload";
import { FetchTreatmentDetailRequestPayload } from "@/data/payload/treatment/fetch-treatment-detail-request-payload";
import { TerminateTreatmentRequestPayload } from "@/data/payload/treatment/pause-treatment-request-payload";
import { ModifyTreatmentMemoRequestPayload } from "@/data/payload/treatment/treatment-memo-mofity-request-payload";
import { safeMapToEntity } from "@/data/repo-Implement/safe-map-to-entity";
import { TreatmentSource } from "@/data/source/treatment-source";
import { ActivityByProgressDayInfoEntity } from "@/domain/entity/treatment/activity-by-progress-day-info-entity";
import { AddTreatmentResponseDto } from "@/data/dto/treatment-source/add-treatment-response-dto";
import { AddTreatmentResponseEntity } from "@/domain/entity/treatment/add-treatment-response-entity";
import { PatientTreatmentTotalInfoEntity } from "@/domain/entity/treatment/patient-treatment-total-info-entity";
import { TreatmentDetailEntity } from "@/domain/entity/treatment/treatment-info-entity";
import { TreatmentRepository } from "@/domain/repository/treatment-repository";
import { SATError, SATResult } from "@sadtx/sat-error";
import { PatientTreatmentTotalInfoMapper } from "../mapper/treatment/patient-treatment-total-info-mapper";

export class TreatmentRepositoryImpl implements TreatmentRepository {
  constructor(private readonly treatmentSource: TreatmentSource) {}

  async addTreatment(
    payload: AddTreatmentRequestPayload
  ): Promise<SATResult<AddTreatmentResponseEntity, SATError>> {
    console.log("[TreatmentRepositoryImpl] :: addTreatment :: 치료 추가 시작", payload);
    return this.mapAddTreatment(await this.treatmentSource.addTreatment(payload), "addTreatment");
  }

  async addTreatmentWithVoucher(
    payload: AddTreatmentRequestPayload
  ): Promise<SATResult<AddTreatmentResponseEntity, SATError>> {
    console.log("[TreatmentRepositoryImpl] :: addTreatmentWithVoucher :: 이용권 소진 치료 추가 시작", payload);
    return this.mapAddTreatment(await this.treatmentSource.addTreatmentWithVoucher(payload), "addTreatmentWithVoucher");
  }

  private mapAddTreatment(
    result: SATResult<AddTreatmentResponseDto, SATError>,
    label: string
  ): SATResult<AddTreatmentResponseEntity, SATError> {
    if (result.isFailure) {
      console.error("[TreatmentRepositoryImpl] ::", label, ":: error", result.error);
      return SATResult.failure(result.error);
    }
    return safeMapToEntity(result.value, AddTreatmentResponseInfoMapper.toEntity, `TreatmentRepositoryImpl::${label}`);
  }

  async modifyTreatmentMemo(
    payload: ModifyTreatmentMemoRequestPayload
  ): Promise<SATResult<void, SATError>> {
    console.log("[TreatmentRepositoryImpl] :: modifyTreatmentMemo :: 치료 메모 수정 시작", payload);

    const result = await this.treatmentSource.modifyTreatmentMemo(payload);

    if (result.isFailure) {
      console.error("[TreatmentRepositoryImpl] :: modifyTreatmentMemo :: error", result.error);
      return SATResult.failure(result.error);
    }

    return SATResult.success(void 0);
  }

  async fetchPatientTreatmentList(
    payload: FetchPatientTreatmentListRequestPayload
  ): Promise<SATResult<PatientTreatmentTotalInfoEntity, SATError>> {
    console.log(
      "[TreatmentRepositoryImpl] :: fetchPatientTreatmentList :: 환자 치료 리스트 조회 시작",
      payload
    );
    const result = await this.treatmentSource.fetchPatientTreatmentList(payload);

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return safeMapToEntity(
      result.value,
      PatientTreatmentTotalInfoMapper.toEntity,
      "TreatmentRepositoryImpl::fetchPatientTreatmentList"
    );
  }

  async fetchTreatmentDetail(
    payload: FetchTreatmentDetailRequestPayload
  ): Promise<SATResult<TreatmentDetailEntity, SATError>> {
    console.log(
      "[TreatmentRepositoryImpl] :: fetchTreatmentDetail :: 치료 상세 정보 조회 시작",
      payload
    );

    const result = await this.treatmentSource.fetchTreatmentDetail(payload);

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return safeMapToEntity(
      result.value,
      TreatmentDetailResponseMapper.toEntity,
      "TreatmentRepositoryImpl::fetchTreatmentDetail"
    );
  }

  async fetchActivityChartData(
    payload: FetchActivityChartDataRequestPayload
  ): Promise<SATResult<ActivityByProgressDayInfoEntity, SATError>> {
    console.log(
      "[TreatmentRepositoryImpl] :: fetchActivityChartData :: 치료 차트 데이터 조회 시작",
      payload
    );
    const result = await this.treatmentSource.fetchAcitivyChartData(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return safeMapToEntity(
      result.value,
      ActivityByProgressDayInfoMapper.toEntity,
      "TreatmentRepositoryImpl::fetchActivityChartData"
    );
  }

  async terminateTreatment(
    payload: TerminateTreatmentRequestPayload
  ): Promise<SATResult<void, SATError>> {
    console.log("[TreatmentRepositoryImpl] :: terminateTreatment :: 치료 중단 시작", payload);

    const result = await this.treatmentSource.terminateTreatment(payload);

    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return SATResult.success(void 0);
  }
}
